import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  version = `2.18.1 ${environment.production ? 'PROD' : 'DEV'}`;

}
